import { Api } from 'src/api';

/** One stage as the form carries it, keyed for React while it is being edited. */
export type StageFormValues = {
  key: string;
  name: string;
  startDate: string | null;
  estimatedFinishDate: string | null;
  finishDate: string | null;
};

export type ServiceOrderFormValues = {
  name: string | null;
  referenceNumber: string | null;
  /** The fee as typed, kept plain so the field can dress it up as money. */
  budget: string | null;
  dayLimit: string | null;
  stages: Array<StageFormValues>;
};

export function newStageKey(): string {
  return Math.random().toString(36).slice(2);
}

export function emptyStage(): StageFormValues {
  return {
    key: newStageKey(),
    name: '',
    startDate: null,
    estimatedFinishDate: null,
    finishDate: null,
  };
}

/**
 * The fee, which the API stores as a whole number of pounds.
 */
function parseFee(text: string): number | null {
  const digits = text.replace(/[^\d]/g, '');
  if (digits === '') return null;
  return parseInt(digits, 10);
}

/**
 * The body the Service Order screen PUTs or POSTs.  The stages' React keys
 * are local to the form, and dropped here along with any blank names.
 */
export function buildServiceOrderWriteBody(
  values: ServiceOrderFormValues,
  companyIri: string,
  projectIri: string | null
): Api.ServiceOrder.W {
  return {
    company: companyIri,
    project: projectIri,
    name: values.name?.trim() || '',
    referenceNumber: values.referenceNumber?.trim() || null,
    budget: parseFee(values.budget ?? ''),
    dayLimit: values.dayLimit?.trim() || null,
    stages: values.stages
      .filter((stage) => stage.name.trim() !== '')
      .map(({ name, startDate, estimatedFinishDate, finishDate }) => ({
        name,
        startDate,
        estimatedFinishDate,
        finishDate,
      })),
  };
}
